/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SET_VISIBILITY_STATE = 'SET_VISIBILITY_STATE';
